import createDecorator from "final-form-calculate";
import { Decorator } from "final-form";
import { FormValues } from "./types";

export const decorators = createDecorator({
  field: 'hasEANUPC',
  updates: (_, __, allValues) => {
    const values = { ...allValues } as FormValues;

    if (!values.hasEANUPC) {
      values.ean = '';
      values.upc = '';
    }

    return values;
  }
}, {
  field: 'hasPLineCLine',
  updates: (_, __, allValues) => {
    const values = { ...allValues } as FormValues;

    if (!values.hasPLineCLine) {
      values.pline_date = null;
      values.pline_value = '';
      values.cline_date = null;
      values.cline_value = '';
    }

    return values;
  }
}) as Decorator<FormValues>;
